import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../lib/apiClient';
import type { Division } from '../types';

const fetchSourceUserDivisions = async (authServiceUuid: string): Promise<Division[]> => {
  const data = await apiClient()
    .get(`broadcast/api/admin/user/${authServiceUuid}/divisions`)
    .json<Division[] | { data: Division[] }>();

  // Handle both array response and wrapped response with data property
  return Array.isArray(data) ? data : data?.data || [];
};

export const useSourceUserDivisionsQuery = (authServiceUuid: string | undefined) => {
  return useQuery({
    queryKey: ['sourceUserDivisions', authServiceUuid],
    queryFn: () => fetchSourceUserDivisions(authServiceUuid!),
    enabled: !!authServiceUuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
